import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-377271d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approval_detail container-lg container-fluid" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary" }, "Review Health Priority Needs", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "px-0" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "details mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Need Title", -1))
const _hoisted_9 = { class: "text-capitalize mb-2" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Program Area", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "SubProgram Area", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_through" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Description of Health Need/Challenge", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Description of required solution", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Target End users", -1))
const _hoisted_18 = {
  key: 0,
  class: "attached_file"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("h6", null, "Attached files")
], -1))
const _hoisted_20 = ["href"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "fw-bold" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Benefit to End Users", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h5", null, _toDisplayString(_ctx.Need.title), 1),
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", null, [
          _createTextVNode(" Submitted by - " + _toDisplayString(_ctx.Need.author_first_name) + " ", 1),
          (_ctx.Need.author_middle_name)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " " + _toDisplayString(_ctx.Need.author_middle_name) + " ", 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.Need.author_last_name), 1)
        ]),
        _createElementVNode("li", null, "Employee Number - " + _toDisplayString(_ctx.Need.author_employee_number), 1),
        _createElementVNode("li", null, "Email Address: " + _toDisplayString(_ctx.Need.author_email), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.Need.title), 1),
        (_ctx.Need?.program_areas?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("p", null, _toDisplayString(_ctx.Need?.program_areas[0]?.name), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.Need?.specific_program_areas?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("p", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Need?.specific_program_areas, (item, i) => {
                  return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(item.name) + ", ", 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_14
      ]),
      _hoisted_15,
      _createElementVNode("p", null, _toDisplayString(_ctx.Need.description), 1),
      _createElementVNode("div", null, [
        _hoisted_16,
        _createElementVNode("p", null, _toDisplayString(_ctx.Need.requirements), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_17,
        _createElementVNode("p", null, _toDisplayString(_ctx.Need.target_users), 1),
        (_ctx.Need?.document_upload?.length > 1)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
              _hoisted_19,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Need.document_upload, (item, i) => {
                return (_openBlock(), _createElementBlock("li", { key: i }, [
                  _createElementVNode("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: item
                  }, [
                    _createElementVNode("img", {
                      src: require(`@/assets/placeholder/${_ctx.getFileExt(item)}.svg`),
                      alt: "placeholder_img ",
                      width: "40"
                    }, null, 8, _hoisted_21),
                    _createElementVNode("span", _hoisted_22, " " + _toDisplayString(_ctx.getFileName(item)), 1)
                  ], 8, _hoisted_20)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _hoisted_23,
        _createElementVNode("p", null, _toDisplayString(_ctx.Need?.benefits), 1)
      ])
    ])
  ]))
}